"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M12 16.205c-.182 0-.356-.031-.523-.094a1.281 1.281 0 0 1-.454-.3l-4.498-4.497a1.285 1.285 0 0 1-.398-.97A1.41 1.41 0 0 1 7.51 8.945c.38-.007.707.128.985.406l2.118 2.118V3.387c0-.39.134-.718.402-.986A1.34 1.34 0 0 1 12 2c.39 0 .717.134.985.401.268.268.402.597.402.986v8.082l2.118-2.118c.273-.278.599-.414.978-.41.378.006.707.148.985.426.262.277.397.602.405.973.008.371-.128.696-.405.974l-4.49 4.497a1.281 1.281 0 0 1-.455.3 1.468 1.468 0 0 1-.523.094ZM4.773 22c-.767 0-1.421-.27-1.962-.81A2.673 2.673 0 0 1 2 19.226v-2.27c0-.39.134-.718.401-.986a1.34 1.34 0 0 1 .986-.401c.389 0 .717.133.985.401.267.268.401.596.401.985v2.27h14.454v-2.27c0-.389.133-.717.401-.985a1.34 1.34 0 0 1 .985-.401c.39 0 .718.133.986.401.267.268.401.596.401.985v2.27c0 .768-.27 1.422-.81 1.963a2.68 2.68 0 0 1-1.963.811H4.773Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};